import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-configuration',
  templateUrl: './product-configuration.component.html',
  styleUrls: ['./product-configuration.component.scss']
})
export class ProductConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
